  export const Constants = {
  deletedMessage: {
    text: 'This message was deleted.',
    icon: 'slash-line',
  },
  forwardedMessage: {
    maxSelectedChannels: 3,
    maxSelectedMessages: 20,
  },
  poll: {
    icon: 'menu-03',
    maxOptions: 12,
  },
  maxTimeBetweenGroupedMessages: 60000, // 1 minute in milliseconds
  maxSelectedMembers: 99,
  maxImageSize: 20000000, // 20MB in bytes
  maxMembersGroup: 1000,
  maxReactionsToShow: 3,
  messageStatus: {
    read: {
      color: 'color:primarySolid500',
    },
     delivered: {
      color: 'color:neutralSolid500',
    },
  },
  maxMentions: 50
}

